//-- Copyright (c) 2021 TMT Insights Group, LLC
import { DashboardConfig } from '@tmt-insights/oms_fe_core';

const dashboardConfig: DashboardConfig = {
  statusCards: [
    {
      name: 'Submit',
      status: 'submit',
      color: 'default',
      icon: 'timelapse',
      ignoreOnPieChart: true,
      filter: ['submit']
    },
    {
      name: 'Awaiting Assets',
      status: 'awaiting_assets',
      color: 'default',
      filter: ['awaiting_assets'],
      icon: 'clock'
    },
    {
      name: 'QC',
      status: 'qc',
      color: 'pending',
      filter: ['qc'],
      icon: 'clock_progress'
    },
    {
      name: 'Processing',
      status: 'processing',
      color: 'info',
      filter: ['processing'],
      icon: 'flight'
    },
    {
      name: 'Completed',
      status: 'complete',
      color: 'success',
      ignoreOnPieChart: true,
      filter: ['complete'],
      icon: 'check'
    }
  ],
  customizeDashboard: true,
  graphList: [
    {
      id: 'open-job-status',
      checked: true
    },
    {
      id: 'completed-jobs',
      checked: true
    },
    {
      id: 'average-times',
      checked: true
    },
    {
      id: 'daily-reports',
      checked: true
    },
    {
      id: 'recent-tasks',
      checked: false
    }
  ],
  graphSettings: {
    'completed-jobs': {
      displayed_job_types: ['edit', 'delivery', 'tech_review']
    }
  },
  maximumGraphsPerRow: 3,
  chartColors: ['#BC13FE', '#FF1493', 'info', '#39FF14']
};

export default dashboardConfig;
